<div [formGroup]="form">
  <dges-login-form formControlName="loginForm"></dges-login-form>
  <div class="login-dialog-actions">
    <button mat-raised-button (click)="login()">Login</button>
    <button mat-raised-button (click)="cancel()">Cancel</button>
  </div>
</div>
